// Material Dashboard 2 PRO React — dark theme override for MuiChip.
// Chips rendered with the default color (e.g. unknown HANGUPCAUSE values like
// SYSTEM_SHUTDOWN, ATTENDED_TRANSFER) fall back to MUI's default colorDefault
// styles, which assume light mode and render dark text on a light gray chip —
// invisible against the dark surface. Force readable styling for the default
// filled chip; explicit color="primary"/"success"/"error" etc. continue to use
// MUI's per-color rules and are unaffected.

import colors from "assets/theme-dark/base/colors";

const { white } = colors;

const chip = {
  styleOverrides: {
    filled: {
      // Affects ONLY the default (no color prop) filled variant. Colored chips
      // (primary/success/warning/error/info) override these via their own
      // class names (filledPrimary, filledSuccess, etc.).
      backgroundColor: "rgba(255, 255, 255, 0.16)",
      color: white.main,
    },
    outlined: {
      color: white.main,
      borderColor: "rgba(255, 255, 255, 0.4)",
    },
  },
};

export default chip;
